import React, { useState } from 'react'
import CompareFiles from './CompareFiles'
import { Modal, Skeleton } from 'antd'

const CompareFilesModal = ({ showModal, handleClose }) => {
    const [animationOfModalHasFinished, setAnimationOfModalHasFinished] = useState(false)

    return (
        <Modal
            title='Compare files'
            open={showModal}
            onCancel={handleClose}
            width='max-width'
            footer={null}
            afterOpenChange={() => setAnimationOfModalHasFinished(true)}
        >
            {animationOfModalHasFinished ? <CompareFiles /> : <Skeleton active />}
        </Modal>
    )
}

export default CompareFilesModal
